import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { theme } from '../../themes/theme'
import { BoldMedBodyText } from '../styles/Text'

const bgColor = {
  waiting: 'rgba(255, 172, 71, 0.2)',
  paid: 'rgba(16, 192, 208, 0.1)',
  rejected: 'rgba(232, 76, 61, 0.1)',
  abandoned: 'rgba(58, 58, 58, 0.1)',
  cancelled: 'rgba(58, 58, 58, 0.1)',
  refunded: 'rgba(58, 58, 58, 0.1)'
}

const borderColor = {
  waiting: 'rgba(255, 172, 71, 1)',
  paid: 'rgba(16, 192, 208, 1)',
  rejected: 'rgba(232, 76, 61, 1)',
  abandoned: 'rgba(58, 58, 58, 1)',
  cancelled: 'rgba(58, 58, 58, 1)',
  refunded: 'rgba(58, 58, 58, 1)'
}

const Background = styled.div`
  display: flex;
  width: fit-content;

  color: #333;
  border: ${props => `1px solid ${borderColor[props.status]}`};
  background-color: ${props => bgColor[props.status]};
  border-radius: ${theme.borderRadius.button};
  padding: 8px 15px;
`

const WhiteBackground = styled(Background)`
  padding: 0;
  background-color: #fff;
`

const Status = styled(BoldMedBodyText)`
  text-transform: capitalize;
`

const BillStatus = ({ status }) => (
  <WhiteBackground>
    <Background status={status.toLowerCase()}>
      <Status>{status.toLowerCase()}</Status>
    </Background>
  </WhiteBackground>
)

BillStatus.propTypes = {
  status: PropTypes.oneOf(['WAITING', 'PAID', 'REJECTED', 'ABANDONED', 'CANCELLED', 'REFUNDED']).isRequired
}

export default BillStatus
